import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="inicio" className="relative min-h-screen flex items-center justify-center bg-cream overflow-hidden" data-id="element-171">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-30" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} data-id="element-172" />

      {/* Decorative elements */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 0.1,
      scale: 1
    }} transition={{
      duration: 1.5,
      ease: 'easeOut'
    }} className="absolute top-20 left-10 md:left-20 font-serif text-[200px] md:text-[300px] text-gold leading-none select-none" data-id="element-173">
        "
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 0.3
    }} transition={{
      duration: 2,
      delay: 0.5
    }} className="absolute bottom-20 right-10 md:right-20 w-32 h-32 md:w-48 md:h-48 border border-gold/30 rounded-full" data-id="element-174" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center" data-id="element-175">
        <motion.h1 initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} className="font-serif text-4xl md:text-5xl lg:text-7xl font-semibold text-charcoal leading-tight mb-8" data-id="element-176">
          Construye tu negocio.
          <br data-id="element-177" />
          <span className="text-gold" data-id="element-178">Expande tu conciencia.</span>
          <br data-id="element-179" />
          Diseña tu vida.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="font-sans text-lg md:text-xl text-charcoal-mid font-light max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-180">
          Mentorías, programas y plataformas para emprendedores conscientes que
          quieren dinero, propósito y libertad.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-181">
          <button onClick={() => scrollToSection('#mentorias')} className="px-8 py-4 bg-gold text-white font-sans font-medium rounded-full hover:bg-gold/90 transition-all duration-300 hover:shadow-lg hover:shadow-gold/20" data-id="element-182">
            Comienza tu transformación
          </button>
          <button onClick={() => scrollToSection('#programas')} className="px-8 py-4 border border-charcoal/30 text-charcoal font-sans font-medium rounded-full hover:border-charcoal hover:bg-charcoal hover:text-cream transition-all duration-300" data-id="element-183">
            Explorar programas
          </button>
        </motion.div>

        {/* Animated gold divider */}
        <motion.div initial={{
        scaleX: 0
      }} animate={{
        scaleX: 1
      }} transition={{
        duration: 1.2,
        delay: 1,
        ease: 'easeOut'
      }} className="mt-20 mx-auto w-24 h-px bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-184" />
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2" data-id="element-185">
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="w-6 h-10 border-2 border-charcoal/30 rounded-full flex items-start justify-center p-2" data-id="element-186">
          <motion.div className="w-1 h-2 bg-charcoal/50 rounded-full" data-id="element-187" />
        </motion.div>
      </motion.div>
    </section>;
}